import { Roles } from '@omnea-digital/toolbox'
import { useQuery } from '@tanstack/react-query'
import { AssessmentsHttpClient } from '@omnea-app/assessments/assessmentsHttpClient'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { useFeatureFlags } from '@omnea-app/fe-org-settings/FeatureFlagsProvider'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'
import { assessmentsQueryKey } from './useListAssessments'

const selectActionNeededCount = (stats: { actionNeededCount: number }) => stats.actionNeededCount

export const useAssessmentsActionNeededCount = () => {
  const { user, getToken } = useAuthenticatedUser()
  const { ENABLE_ASSESSMENTS } = useFeatureFlags()

  return useQuery({
    enabled: user.role !== Roles.SUPPLIER && ENABLE_ASSESSMENTS,
    queryKey: [assessmentsQueryKey, 'stats', user.id],
    staleTime: Infinity,
    gcTime: Infinity,
    queryFn: async () => {
      const authorization = await getToken()
      const assessmentsApiClient = new AssessmentsHttpClient({ authorization })

      const { data, error } = await assessmentsApiClient.GET('/get-stats')

      if (error) throwIfApiError(error)

      return data.assessmentStats
    },
    select: selectActionNeededCount,
  })
}
